/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Forms,
  useInvoiceFormContext,
} from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button } from 'antd';
import { useRef, useState } from 'react';
import DuplicateInvoiceErrorModal from '../DuplicateInvoiceErrorModal';
import invoiceHandleError from '@/core/domain/invoiceTransmissionHub/invoice.error.transmit';
import { useTransmitInvoiceHub } from '@/core/domain/invoiceTransmissionHub/Invoice/Invoice.hooks';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { useTransmitInvoiceNfs } from '@/core/domain/nfs/NfseController/NfseController.hooks';

interface Props {
  type: InvoiceType;
}

const TransmitInternalButton = ({ type }: Props) => {
  const { handleSubmit, invoiceId, instanceForms } = useInvoiceFormContext();

  const [duplicateError, setDuplicateError] = useState<any>();

  const isTransmittingRef = useRef(false);
  const [isTransmitting, setIsTransmitting] = useState(false);

  const transmitInvoiceHub = useTransmitInvoiceHub();
  const transmitInvoiceNfs = useTransmitInvoiceNfs();

  const transmit = async (newNumber?: number) => {
    if (isTransmittingRef.current) {
      return;
    }

    isTransmittingRef.current = true;
    setIsTransmitting(true);

    try {
      await Promise.all(
        Object.keys(instanceForms).map((key: unknown) =>
          instanceForms[key as keyof Forms]?.validateFields(),
        ),
      );

      await handleSubmit().then(async () => {
        type === InvoiceType.NFS
          ? await transmitInvoiceNfs.mutateAsync({
              invoiceId: Number(invoiceId),
              newNumber,
            })
          : await transmitInvoiceHub.mutateAsync({
              invoiceId: Number(invoiceId),
              newNumber,
              type,
            });
      });
    } catch (err) {
      const dataError = invoiceHandleError(err);

      if (dataError?.message.includes('Rejeicao: Duplicidade de NF-e')) {
        setDuplicateError(dataError);
      }
    } finally {
      isTransmittingRef.current = false;
      setIsTransmitting(false);
    }
  };

  const loading =
    isTransmitting ||
    transmitInvoiceNfs.isLoading ||
    transmitInvoiceHub.isLoading;

  return (
    <>
      {loading && (
        <ModalLoadingOverlay
          messages={['Transmitindo nota...', 'Validando dados da nota...']}
        />
      )}

      <Button
        loading={loading}
        block
        type="primary"
        disabled={
          loading || !hasPermissions([Authorities.FISCAL_INVOICE_TRANSMIT])
        }
        onClick={() => transmit()}
      >
        Transmitir
      </Button>

      <DuplicateInvoiceErrorModal
        opened={!!duplicateError}
        onClose={() => {
          setDuplicateError(undefined);
        }}
        dataError={duplicateError}
        invoiceId={Number(invoiceId)}
        transmit={transmit}
      />
    </>
  );
};

export default TransmitInternalButton;
